module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-09-07 at 3.29.22 PM.004f7648.png";